import { useEffect, useState } from 'react';
import { assets } from '../assets/assets';
import VideoCollection from '../components/VideoCollection';
import { CiSearch } from "react-icons/ci";
import ProductItem from '../components/ProductItem';
import { IoIosArrowDown } from "react-icons/io";
import axiosInstance from '../api/axiosInstance';

const ExploreCampaign = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategoryId, setActiveCategoryId] = useState(null); // null = 'All'
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(false);

  // Fetch categories and initial campaigns on mount
  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get('/campaign');
        if (response.data.success) {
          setCampaigns(response.data.campaign_list);
          setCategories(response.data.categories_list || []);
        }
      } catch (error) {
        console.error('Initial API error:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchInitialData();
  }, []);

  // Fetch campaigns on category change
  useEffect(() => {
    const fetchCampaignsByCategory = async () => {
      setLoading(true);
      try {
        const params = activeCategoryId ? { category_id: activeCategoryId } : {};
        const response = await axiosInstance.get('/campaign', { params });

        if (response.data.success) {
          setCampaigns(response.data.campaign_list);
        }
      } catch (error) {
        console.error('Error fetching campaigns by category:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCampaignsByCategory();
  }, [activeCategoryId]);

  // Filter based on search term only
  const filteredCampaigns = campaigns.filter(campaign =>
    campaign.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* Banner */}
      <div className="banner_sec explore_banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="content text-center text-sm-start">
                <h1 className="title text-white">Explore Campaigns</h1>
                <p className="subtitle text-white mb-3 mb-sm-5">Every life matters. Extend your support to save a life!</p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="right-img">
                <img src={assets.explore_banner_img} alt="Explore" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <VideoCollection />

      {/* Filter Section */}
      <div className="product-filter">
        <div className="container">
          <div className="row">
            {/* Sidebar Filters */}
            <div className="col-lg-3">
              <div className="filter-section-area">
                <div onClick={() => setShowFilter(!showFilter)} className="div-flex">
                  <h3>Categories</h3>
                  <IoIosArrowDown className={`${showFilter ? 'rotate-icon' : ''}`} />
                </div>
                <div className={`filter-content ${showFilter ? '' : 'hide'}`}>
                  <ul>
                    <li
                      className={`filter-item monthly_donation_sec ${activeCategoryId === null ? 'active' : ''}`}
                      onClick={() => setActiveCategoryId(null)}
                    >
                      <div className="icon">
                        <img src={assets.all_products_icon} className="img-fluid" alt="All" />
                      </div>
                      <div className="category_name"><p>All</p></div>
                    </li>

                    {/* Dynamic Categories */}
                    {categories.map(cat => (
                      <li
                        key={cat.id}
                        className={`filter-item monthly_donation_sec ${activeCategoryId === cat.id ? 'active' : ''}`}
                        onClick={() => setActiveCategoryId(cat.id)}
                      >
                        <div className="icon">
                          {/* Replace with dynamic icons if you implement a map or font-awesome handler */}
                          <img src={assets[`filter_${cat.name.replace(/\s+/g, '_').toLowerCase()}_icon`] || assets.all_products_icon} alt={cat.name} />
                        </div>
                        <div className="category_name"><p>{cat.name}</p></div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* Campaign List */}
            <div className="col-lg-9">
              <div className="product-filter-item">
                <div className="our_campaigns">
                  <div className="search">
                    <form onSubmit={(e) => e.preventDefault()}>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search for campaign"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button type="submit" className="input-group-text"><CiSearch /></button>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="product-filter-items">
                  <div className="row">
                    {loading ? (
                      <div className="row">
                        {[...Array(6)].map((_, i) => (
                          <div className="col-md-4 mb-4" key={i}>
                            <div className="campaign-skeleton skeleton-box"></div>
                          </div>
                        ))}
                      </div>
                    ) : filteredCampaigns.length === 0 ? (
                      <div className="text-center my-5 w-100" key={1}>
                        <img
                          src="/images/empty-state.png"
                          alt="No campaigns"
                          style={{ maxWidth: '200px', marginBottom: '20px' }}
                        />
                        <h5>No campaigns found in this category</h5>
                        <p>Try selecting a different category or check back later.</p>
                      </div>
                    ) : (
                      filteredCampaigns.map((item) => (
                        <ProductItem
                          key={item.id}
                          id={item.id}
                          slug={item.slug}
                          thumbnail_image={item.thumbnail_imge}
                          name={item.name}
                          description={item.description}
                          target={item.raise_amount}
                          endDate={item.end_date}
                          orderCount={item.order_detail_count}
                        />
                      ))
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
};

export default ExploreCampaign;
